export const countryData = {
    countries: [
        {
            value: "India",
            label: "India",
            states: [
                {
                    value: "Gujarat", label: "Gujarat",
                    cities: [
                        {
                            label: "Surat",
                            value: "surat"
                        },
                        {
                            label: "Abrama",
                            value: "Abrama"
                        },
                        {
                            label: "Adalaj",
                            value: "Adalaj"
                        },
                        {
                            label: "Adityana",
                            value: "Adityana"
                        },
                        {
                            label: "Advana",
                            value: "Advana"
                        },
                        {
                            label: "Ahmedabad",
                            value: "Ahmedabad"
                        },
                        {
                            label: "Ahwa",
                            value: "Ahwa"
                        },
                        {
                            label: "Alang",
                            value: "Alang"
                        },
                        {
                            label: "Ambaji",
                            value: "Ambaji"
                        },
                        {
                            label: "Ambaliyasan",
                            value: "Ambaliyasan"
                        },
                        {
                            label: "Amod",
                            value: "Amod"
                        },
                        {
                            label: "Amreli",
                            value: "Amreli"
                        },
                        {
                            label: "Amroli",
                            value: "Amroli"
                        },
                        {
                            label: "Anand",
                            value: "Anand"
                        },
                        {
                            label: "Andada",
                            value: "Andada"
                        },
                        {
                            label: "Anjar",
                            value: "Anjar"
                        },
                        {
                            label: "Anklav",
                            value: "Anklav"
                        },
                        {
                            label: "Ankleshwar",
                            value: "Ankleshwar"
                        },
                        {
                            label: "Anklesvar INA",
                            value: "Anklesvar INA"
                        },
                        {
                            label: "Antaliya",
                            value: "Antaliya"
                        },
                        {
                            label: "Arambhada",
                            value: "Arambhada"
                        },
                        {
                            label: "Asarma",
                            value: "Asarma"
                        },
                        {
                            label: "Atul",
                            value: "Atul"
                        },
                        {
                            label: "Babra",
                            value: "Babra"
                        },
                        {
                            label: "Bag-e-Firdosh",
                            value: "Bag-e-Firdosh",

                        },
                        {
                            label: "Bagasara",
                            value: "Bagasara"
                        },
                        {
                            label: "Bahadarpar",
                            value: "Bahadarpar"
                        },
                        {
                            label: "Bajipura",
                            value: "Bajipura"
                        },
                        {
                            label: "Bajva",
                            value: "Bajva"
                        },
                        {
                            label: "Balasinor",
                            value: "Balasinor"
                        },
                        {
                            label: "Banaskantha",
                            value: "Banaskantha"
                        },
                        {
                            label: "Bansda",
                            value: "Bansda"
                        },
                        {
                            label: "Bantva",
                            value: "Bantva"
                        },
                        {
                            label: "Bardoli",
                            value: "Bardoli"
                        },
                        {
                            label: "Gandhidham",
                            value: "Gandhidham"
                        },
                        {
                            label: "Gandhinagar",
                            value: "Gandhinagar"
                        },
                        {
                            label: "Gariadhar",
                            value: "Gariadhar"
                        },
                    ]
                },
                {
                    value: "Maharashtra", label: "Maharashtra",
                    cities: [
                        {value: "Kolhapur", label: 'Kolhapur'},
                        {value: "Pune", label: 'Pune'},
                        {value: "Mumbai", label: "Mumbai"},
                        {
                            label: "Chakan",
                            value: "Chakan"
                        },
                        {
                            label: "Chalisgaon",
                            value: "Chalisgaon"
                        },
                        {
                            label: "Chandrapur",
                            value: "Chandrapur"
                        },
                        {
                            label: "Chandur",
                            value: "Chandur"
                        },
                        {
                            label: "Chandur Bazar",
                            value: "Chandur Bazar"
                        },
                        {
                            label: "Chandvad",
                            value: "Chandvad"
                        },
                        {
                            label: "Chicholi",
                            value: "Chicholi"
                        },
                        {
                            label: "Chikhala",
                            value: "Chikhala"
                        },
                        {
                            label: "Chikhaldara",
                            value: "Chikhaldara"
                        },
                        {
                            label: "Chikhli",
                            value: "Chikhli"
                        },
                    ]
                },
                {
                    value: "Goa", label: "Goa",
                    cities: [
                        {
                            label: "Aldona",
                            value: "Aldona"
                        },
                        {
                            label: "Altinho",
                            value: "Altinho"
                        },
                        {
                            label: "Aquem",
                            value: "Aquem"
                        },
                        {
                            label: "Arpora",
                            value: "Arpora"
                        },
                        {
                            label: "Bambolim",
                            value: "Bambolim"
                        },
                        {
                            label: "Bandora",
                            value: "Bandora"
                        },
                        {
                            label: "Bardez",
                            value: "Bardez"
                        },
                        {
                            label: "Benaulim",
                            value: "Benaulim"
                        },
                        {
                            label: "Betora",
                            value: "Betora"
                        },
                        {
                            label: "Bicholim",
                            value: "Bicholim"
                        },
                        {
                            label: "Calapor",
                            value: "Calapor"
                        },
                    ]
                },
                {
                    value: "Andaman and Nicobar Islands",
                    label: "Andaman and Nicobar Islands",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Andhra Pradesh",
                    label: "Andhra Pradesh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Arunachal Pradesh",
                    label: "Arunachal Pradesh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Assam",
                    label: "Assam",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Bihar",
                    label: "Bihar",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Chandigarh",
                    label: "Chandigarh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Chhattisgarh",
                    label: "Chhattisgarh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Dadra and Nagar Haveli",
                    label: "Dadra and Nagar Haveli",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Daman and Diu",
                    label: "Daman and Diu",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Delhi",
                    label: "Delhi",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Haryana",
                    label: "Haryana",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Himachal Pradesh",
                    label: "Himachal Pradesh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Jammu and Kashmir",
                    label: "Jammu and Kashmir",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Jharkhand",
                    label: "Jharkhand",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Karnataka",
                    label: "Karnataka",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Kerala",
                    label: "Kerala",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Ladakh",
                    label: "Ladakh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Lakshadweep",
                    label: "Lakshadweep",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Madhya Pradesh",
                    label: "Madhya Pradesh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Manipur",
                    label: "Manipur",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Meghalaya",
                    label: "Meghalaya",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Mizoram",
                    label: "Mizoram",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Nagaland",
                    label: "Nagaland",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Narora",
                    label: "Narora",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Odisha",
                    label: "Odisha",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Pondicherry",
                    label: "Pondicherry",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Punjab",
                    label: "Punjab",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Rajasthan",
                    label: "Rajasthan",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Sikkim",
                    label: "Sikkim",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Tamil Nadu",
                    label: "Tamil Nadu",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Telangana",
                    label: "Telangana",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Tripura",
                    label: "Tripura",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Uttar Pradesh",
                    label: "Uttar Pradesh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Uttarakhand",
                    label: "Uttarakhand",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "West Bengal",
                    label: "West Bengal",
                    cities: [{label: "", value: ""}]
                }
            ]
        },
        {
            value: "United States",
            label: "United States",
            states: [
                {
                    value: "Alabama", label: "Alabama",
                    cities: [
                        {value: "Barcelona", label: 'Barcelona'},
                        {
                            label: "Alabaster",
                            value: "Alabaster"
                        },
                        {
                            label: "Albertville",
                            value: "Albertville"
                        },
                        {
                            label: "Alexander City",
                            value: "Alexander City"
                        },
                        {
                            label: "Anniston",
                            value: "Anniston"
                        },
                        {
                            label: "Arab",
                            value: "Arab"
                        },
                        {
                            label: "Ashville",
                            value: "Ashville"
                        },

                    ]
                },
                {
                    value: "California",
                    label: "California",
                    cities: [
                        {value: "Abbeville", label: 'Abbeville'},
                        {value: "Adamsville", label: 'Adamsville'},
                        {
                            label: "Acton",
                            value: "Acton"
                        },
                        {
                            label: "Adelanto",
                            value: "Adelanto"
                        },
                        {
                            label: "Agoura Hills",
                            value: "Agoura Hills"
                        },
                        {
                            label: "Aguanga",
                            value: "Aguanga"
                        },
                        {
                            label: "Alamo",
                            value: "Alamo"
                        },
                        {
                            label: "Albany",
                            value: "Albany"
                        },
                        {
                            label: "Alhambra",
                            value: "Alhambra"
                        },
                        {
                            label: "Aliso Viejo",
                            value: "Aliso Viejo"
                        },
                        {
                            label: "Alondra Park",
                            value: "Alondra Park"
                        },
                        {
                            label: "Alpine",
                            value: "Alpine"
                        },
                        {
                            label: "Alta Loma",
                            value: "Alta Loma"
                        },

                    ]
                },
                {
                    value: "Alaska",
                    label: "Alaska", cities: [{label: "", value: ""}]
                },
                {
                    value: "Arizona",
                    label: "Arizona", cities: [{label: "", value: ""}]
                },
                {
                    value: "Arkansas",
                    label: "Arkansas", cities: [{label: "", value: ""}]
                },
                {
                    value: "Colorado",
                    label: "Colorado", cities: [{label: "", value: ""}]
                },
                {
                    value: "Connecticut",
                    label: "Connecticut", cities: [{label: "", value: ""}]
                },
                {
                    value: "Delaware",
                    label: "Delaware", cities: [{label: "", value: ""}]
                },
                {
                    value: "District of Columbia",
                    label: "District of Columbia", cities: [{label: "", value: ""}]
                },
                {
                    value: "Florida",
                    label: "Florida", cities: [{label: "", value: ""}]
                },
                {
                    value: "Georgia",
                    label: "Georgia", cities: [{label: "", value: ""}]
                },
                {
                    value: "Hawaii",
                    label: "Hawaii", cities: [{label: "", value: ""}]
                },
                {
                    value: "Idaho",
                    label: "Idaho", cities: [{label: "", value: ""}]
                },
                {
                    value: "Illinois",
                    label: "Illinois", cities: [{label: "", value: ""}]
                },
                {
                    value: "Indiana",
                    label: "Indiana", cities: [{label: "", value: ""}]
                },
                {
                    value: "Iowa",
                    label: "Iowa", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kansas",
                    label: "Kansas", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kentucky",
                    label: "Kentucky", cities: [{label: "", value: ""}]
                },
                {
                    value: "Louisiana",
                    label: "Louisiana", cities: [{label: "", value: ""}]
                },
                {
                    value: "Maine",
                    label: "Maine", cities: [{label: "", value: ""}]
                },
                {
                    value: "Maryland",
                    label: "Maryland", cities: [{label: "", value: ""}]
                },
                {
                    value: "Massachusetts",
                    label: "Massachusetts", cities: [{label: "", value: ""}]
                },
                {
                    value: "Michigan",
                    label: "Michigan", cities: [{label: "", value: ""}]
                },
                {
                    value: "Minnesota",
                    label: "Minnesota", cities: [{label: "", value: ""}]
                },
                {
                    value: "Mississippi",
                    label: "Mississippi", cities: [{label: "", value: ""}]
                },
                {
                    value: "Missouri",
                    label: "Missouri", cities: [{label: "", value: ""}]
                },
                {
                    value: "Montana",
                    label: "Montana", cities: [{label: "", value: ""}]
                },
                {
                    value: "Nebraska",
                    label: "Nebraska", cities: [{label: "", value: ""}]
                },
                {
                    value: "Nevada",
                    label: "Nevada", cities: [{label: "", value: ""}]
                },
                {
                    value: "New Hampshire",
                    label: "New Hampshire", cities: [{label: "", value: ""}]
                },
                {
                    value: "New Jersey",
                    label: "New Jersey", cities: [{label: "", value: ""}]
                },
                {
                    value: "New Mexico",
                    label: "New Mexico", cities: [{label: "", value: ""}]
                },
                {
                    value: "New York",
                    label: "New York", cities: [{label: "", value: ""}]
                },
                {
                    value: "North Carolina",
                    label: "North Carolina", cities: [{label: "", value: ""}]
                },
                {
                    value: "North Dakota",
                    label: "North Dakota", cities: [{label: "", value: ""}]
                },
                {
                    value: "Ohio",
                    label: "Ohio", cities: [{label: "", value: ""}]
                },
                {
                    value: "Oklahoma",
                    label: "Oklahoma", cities: [{label: "", value: ""}]
                },
                {
                    value: "Ontario",
                    label: "Ontario", cities: [{label: "", value: ""}]
                },
                {
                    value: "Oregon",
                    label: "Oregon", cities: [{label: "", value: ""}]
                },
                {
                    value: "Pennsylvania",
                    label: "Pennsylvania", cities: [{label: "", value: ""}]
                },
                {
                    value: "Ramey",
                    label: "Ramey", cities: [{label: "", value: ""}]
                },
                {
                    value: "Rhode Island",
                    label: "Rhode Island", cities: [{label: "", value: ""}]
                },
                {
                    value: "South Carolina",
                    label: "South Carolina", cities: [{label: "", value: ""}]
                },
                {
                    value: "South Dakota",
                    label: "South Dakota", cities: [{label: "", value: ""}]
                },
                {
                    value: "Sublimity",
                    label: "Sublimity", cities: [{label: "", value: ""}]
                },
                {
                    value: "Tennessee",
                    label: "Tennessee", cities: [{label: "", value: ""}]
                },
                {
                    value: "Texas",
                    label: "Texas", cities: [{label: "", value: ""}]
                },
                {
                    value: "Trimble",
                    label: "Trimble", cities: [{label: "", value: ""}]
                },
                {
                    value: "Utah",
                    label: "Utah", cities: [{label: "", value: ""}]
                },
                {
                    value: "Vermont",
                    label: "Vermont", cities: [{label: "", value: ""}]
                },
                {
                    value: "Virginia",
                    label: "Virginia", cities: [{label: "", value: ""}]
                },
                {
                    value: "Washington",
                    label: "Washington", cities: [{label: "", value: ""}]
                },
                {
                    value: "West Virginia",
                    label: "West Virginia", cities: [{label: "", value: ""}]
                },
                {
                    value: "Wisconsin",
                    label: "Wisconsin", cities: [{label: "", value: ""}]
                },
                {
                    value: "Wyoming",
                    label: "Wyoming", cities: [{label: "", value: ""}]
                }
            ]
        },
        {
            value: "Mexico", label: "Mexico",
            states: [
                {
                    value: "Aguascalientes",
                    label: "Aguascalientes",
                    cities: [
                        {
                            label: "Aguascalientes",
                            value: "Aguascalientes"
                        },
                        {
                            label: "Asientos",
                            value: "Asientos"
                        },
                        {
                            label: "Calvillo",
                            value: "Calvillo"
                        },
                        {
                            label: "Cosio",
                            value: "Cosio"
                        },
                        {
                            label: "Margaritas",
                            value: "Margaritas"
                        },
                        {
                            label: "Ojocaliente",
                            value: "Ojocaliente"
                        },
                        {
                            label: "Pabellon de Arteaga",
                            value: "Pabellon de Arteaga"
                        },
                        {
                            label: "Pabellon de Hidalgo",
                            value: "Pabellon de Hidalgo"
                        },
                        {
                            label: "Palo Alto",
                            value: "Palo Alto"
                        },
                        {
                            label: "Rincon de Romos",
                            value: "Rincon de Romos"
                        },
                    ]
                },
                {
                    value: "Campeche", label: "Campeche",
                    cities: [
                        {value: "Atasta", label: 'Atasta'},
                        {
                            label: "Becal",
                            value: "Becal"
                        },
                        {
                            label: "Bolonchen",
                            value: "Bolonchen"
                        },
                        {
                            label: "Calkini",
                            value: "Calkini"
                        },
                        {
                            label: "Candelaria",
                            value: "Candelaria"
                        },
                        {
                            label: "Carmen",
                            value: "Carmen"
                        },
                        {
                            label: "Champoton",
                            value: "Champoton"
                        },
                        {
                            label: "China",
                            value: "China"
                        },
                        {
                            label: "Dzitbalche",
                            value: "Dzitbalche"
                        },
                        {
                            label: "Escarcega",
                            value: "Escarcega"
                        },
                        {
                            label: "Hecelchakan",
                            value: "Hecelchakan"
                        },
                    ]
                },
                {
                    value: "Baja California Sur",
                    label: "Baja California Sur", cities: [{label: "", value: ""}]
                },
                {
                    value: "Chiapas",
                    label: "Chiapas", cities: [{label: "", value: ""}]
                },
                {
                    value: "Chihuahua",
                    label: "Chihuahua", cities: [{label: "", value: ""}]
                },
                {
                    value: "Coahuila",
                    label: "Coahuila", cities: [{label: "", value: ""}]
                },
                {
                    value: "Colima",
                    label: "Colima", cities: [{label: "", value: ""}]
                },
                {
                    value: "Distrito Federal",
                    label: "Distrito Federal", cities: [{label: "", value: ""}]
                },
                {
                    value: "Durango",
                    label: "Durango", cities: [{label: "", value: ""}]
                },
                {
                    value: "Estado de Mexico",
                    label: "Estado de Mexico", cities: [{label: "", value: ""}]
                },
                {
                    value: "Guanajuato",
                    label: "Guanajuato", cities: [{label: "", value: ""}]
                },
                {
                    value: "Guerrero",
                    label: "Guerrero", cities: [{label: "", value: ""}]
                },
                {
                    value: "Hidalgo",
                    label: "Hidalgo", cities: [{label: "", value: ""}]
                },
                {
                    value: "Jalisco",
                    label: "Jalisco", cities: [{label: "", value: ""}]
                },
                {
                    value: "Mexico",
                    label: "Mexico", cities: [{label: "", value: ""}]
                },
                {
                    value: "Michoacan",
                    label: "Michoacan", cities: [{label: "", value: ""}]
                },
                {
                    value: "Morelos",
                    label: "Morelos", cities: [{label: "", value: ""}]
                },
                {
                    value: "Nayarit",
                    label: "Nayarit", cities: [{label: "", value: ""}]
                },
                {
                    value: "Nuevo Leon",
                    label: "Nuevo Leon", cities: [{label: "", value: ""}]
                },
                {
                    value: "Oaxaca",
                    label: "Oaxaca", cities: [{label: "", value: ""}]
                },
                {
                    value: "Puebla",
                    label: "Puebla", cities: [{label: "", value: ""}]
                },
                {
                    value: "Queretaro",
                    label: "Queretaro", cities: [{label: "", value: ""}]
                },
                {
                    value: "Quintana Roo",
                    label: "Quintana Roo", cities: [{label: "", value: ""}]
                },
                {
                    value: "San Luis Potosi",
                    label: "San Luis Potosi", cities: [{label: "", value: ""}]
                },
                {
                    value: "Sinaloa",
                    label: "Sinaloa", cities: [{label: "", value: ""}]
                },
                {
                    value: "Sonora",
                    label: "Sonora", cities: [{label: "", value: ""}]
                },
                {
                    value: "Tabasco",
                    label: "Tabasco", cities: [{label: "", value: ""}]
                },
                {
                    value: "Tamaulipas",
                    label: "Tamaulipas", cities: [{label: "", value: ""}]
                },
                {
                    value: "Tlaxcala",
                    label: "Tlaxcala", cities: [{label: "", value: ""}]
                },
                {
                    value: "Veracruz",
                    label: "Veracruz", cities: [{label: "", value: ""}]
                },
                {
                    value: "Yucatan",
                    label: "Yucatan", cities: [{label: "", value: ""}]
                },
                {
                    value: "Zacatecas",
                    label: "Zacatecas", cities: [{label: "", value: ""}]
                }
            ]
        },
        {
            value: "United Kingdom", label: "United Kingdom",
            states: [
                {
                    value: "Aberdeen",
                    label: "Aberdeen",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Aberdeenshire",
                    label: "Aberdeenshire",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Argyll",
                    label: "Argyll",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Armagh",
                    label: "Armagh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Bedfordshire",
                    label: "Bedfordshire",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Belfast",
                    label: "Belfast", cities: [{label: "", value: ""}]
                },
                {
                    value: "Berkshire",
                    label: "Berkshire",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Birmingham",
                    label: "Birmingham",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Brechin",
                    label: "Brechin",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Bridgnorth",
                    label: "Bridgnorth",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Bristol",
                    label: "Bristol",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Buckinghamshire",
                    label: "Buckinghamshire",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Cambridge",
                    label: "Cambridge",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Cambridgeshire",
                    label: "Cambridgeshire",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Channel Islands",
                    label: "Channel Islands",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Cheshire",
                    label: "Cheshire", cities: [{label: "", value: ""}]
                },
                {
                    value: "Cleveland",
                    label: "Cleveland",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Co Fermanagh",
                    label: "Co Fermanagh",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Conwy",
                    label: "Conwy",
                    cities: [{label: "", value: ""}]
                },
                {
                    value: "Cumbria",
                    label: "Cumbria", cities: [{label: "", value: ""}]
                },
                {
                    value: "Derby",
                    label: "Derby", cities: [{label: "", value: ""}]
                },

                {
                    value: "Durham",
                    label: "Durham", cities: [{label: "", value: ""}]
                },
                {
                    value: "East Dunbartonshire",
                    label: "East Dunbartonshire", cities: [{label: "", value: ""}]
                },

                {
                    value: "East Yorkshire",
                    label: "East Yorkshire", cities: [{label: "", value: ""}]
                },
                {
                    value: "England",
                    label: "England", cities: [{label: "", value: ""}]
                },
            ]
        },
        {
            value: "Canada", label: "Canada",
            states: [
                {
                    value: "Alberta",
                    label: "Alberta", cities: [{label: "", value: ""}]

                },
                {
                    value: "British Columbia",
                    label: "British Columbia", cities: [{label: "", value: ""}]

                },
                {
                    value: "Manitoba",
                    label: "Manitoba", cities: [{label: "", value: ""}]

                },
                {
                    value: "New Brunswick",
                    label: "New Brunswick", cities: [{label: "", value: ""}]

                },
                {
                    value: "Newfoundland and Labrador",
                    label: "Newfoundland and Labrador", cities: [{label: "", value: ""}]

                },
                {
                    value: "Northwest Territories",
                    label: "Northwest Territories", cities: [{label: "", value: ""}]

                },
                {
                    value: "Nova Scotia",
                    label: "Nova Scotia", cities: [{label: "", value: ""}]

                },
                {
                    value: "Nunavut",
                    label: "Nunavut", cities: [{label: "", value: ""}]

                },
                {
                    value: "Ontario",
                    label: "Ontario", cities: [{label: "", value: ""}]

                },
                {
                    value: "Prince Edward Island",
                    label: "Prince Edward Island", cities: [{label: "", value: ""}]

                },
                {
                    value: "Quebec",
                    label: "Quebec", cities: [{label: "", value: ""}]

                },
                {
                    value: "Saskatchewan",
                    label: "Saskatchewan", cities: [{label: "", value: ""}]

                },
                {
                    value: "Yukon",
                    label: "Yukon", cities: [{label: "", value: ""}]

                }
            ]
        },
        {
            value: "Germany", label: "Germany",
            states: [
                {
                    value: "Auvergne",
                    label: "Auvergne",
                    cities: [{label: "", value: ""}]

                },
                {
                    value: "Baden-Wurttemberg",
                    label: "Baden-Wurttemberg", cities: [{label: "", value: ""}]
                },
                {
                    value: "Bavaria",
                    label: "Bavaria", cities: [{label: "", value: ""}]
                },
                {
                    value: "Bayern",
                    label: "Bayern", cities: [{label: "", value: ""}]
                },
                {
                    value: "Beilstein Wurtt",
                    label: "Beilstein Wurtt", cities: [{label: "", value: ""}]
                },
                {
                    value: "Berlin",
                    label: "Berlin", cities: [{label: "", value: ""}]
                },
                {
                    value: "Brandenburg",
                    label: "Brandenburg", cities: [{label: "", value: ""}]
                },
                {
                    value: "Bremen",
                    label: "Bremen", cities: [{label: "", value: ""}]
                },
                {
                    value: "Dreisbach",
                    label: "Dreisbach", cities: [{label: "", value: ""}]
                },
                {
                    value: "Freistaat Bayern",
                    label: "Freistaat Bayern", cities: [{label: "", value: ""}]
                },
                {
                    value: "Hamburg",
                    label: "Hamburg", cities: [{label: "", value: ""}]
                },
                {
                    value: "Hannover",
                    label: "Hannover", cities: [{label: "", value: ""}]
                },
            ]
        },
        {
            value: "Australia", label: "Australia",
            states: [
                {
                    value: "New South Wales",
                    label: "New South Wales", cities: [{label: "", value: ""}]
                },
                {
                    value: "Queensland",
                    label: "Queensland", cities: [{label: "", value: ""}]
                },
                {
                    value: "South Australia",
                    label: "South Australia", cities: [{label: "", value: ""}]
                },
                {
                    value: "Tasmania",
                    label: "Tasmania", cities: [{label: "", value: ""}]
                },
                {
                    value: "Victoria",
                    label: "Victoria", cities: [{label: "", value: ""}]
                },
                {
                    value: "Western Australia",
                    label: "Western Australia", cities: [{label: "", value: ""}]
                }
            ]
        },
        {
            value: "Japan", label: "Japan",
            states: [{
                value: "Aichi",
                label: "Aichi", cities: [{label: "", value: ""}]
            },
                {
                    value: "Akita",
                    label: "Akita", cities: [{label: "", value: ""}]
                },
                {
                    value: "Aomori",
                    label: "Aomori", cities: [{label: "", value: ""}]
                },
                {
                    value: "Chiba",
                    label: "Chiba", cities: [{label: "", value: ""}]
                },
                {
                    value: "Ehime",
                    label: "Ehime", cities: [{label: "", value: ""}]
                },
                {
                    value: "Fukui",
                    label: "Fukui", cities: [{label: "", value: ""}]
                },
                {
                    value: "Fukuoka",
                    label: "Fukuoka", cities: [{label: "", value: ""}]
                },
                {
                    value: "Fukushima",
                    label: "Fukushima", cities: [{label: "", value: ""}]
                },
                {
                    value: "Gifu",
                    label: "Gifu", cities: [{label: "", value: ""}]
                },
                {
                    value: "Gumma",
                    label: "Gumma", cities: [{label: "", value: ""}]
                },
                {
                    value: "Hiroshima",
                    label: "Hiroshima", cities: [{label: "", value: ""}]
                },]
        },
        {
            value: "Sweden", label: "Sweden",
            states: [
                {
                    value: "Alvsborgs Lan",
                    label: "Alvsborgs Lan", cities: [{label: "", value: ""}]
                },
                {
                    value: "Angermanland",
                    label: "Angermanland", cities: [{label: "", value: ""}]
                },
                {
                    value: "Blekinge",
                    label: "Blekinge", cities: [{label: "", value: ""}]
                },
                {
                    value: "Bohuslan",
                    label: "Bohuslan", cities: [{label: "", value: ""}]
                },
                {
                    value: "Dalarna",
                    label: "Dalarna", cities: [{label: "", value: ""}]
                },
                {
                    value: "Gavleborg",
                    label: "Gavleborg", cities: [{label: "", value: ""}]
                },
                {
                    value: "Gaza",
                    label: "Gaza", cities: [{label: "", value: ""}]
                },
                {
                    value: "Gotland",
                    label: "Gotland", cities: [{label: "", value: ""}]
                },
                {
                    value: "Halland",
                    label: "Halland", cities: [{label: "", value: ""}]
                },
                {
                    value: "Jamtland",
                    label: "Jamtland", cities: [{label: "", value: ""}]
                },
                {
                    value: "Jonkoping",
                    label: "Jonkoping", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kalmar",
                    label: "Kalmar", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kristianstads",
                    label: "Kristianstads", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kronoberg",
                    label: "Kronoberg", cities: [{label: "", value: ""}]
                },
                {
                    value: "Norrbotten",
                    label: "Norrbotten", cities: [{label: "", value: ""}]
                },
                {
                    value: "Orebro",
                    label: "Orebro", cities: [{label: "", value: ""}]
                },
                {
                    value: "Ostergotland",
                    label: "Ostergotland", cities: [{label: "", value: ""}]
                },
            ]
        },
        {
            value: "Switzerland", label: "Switzerland",
            states: [
                {
                    value: "Aargau",
                    label: "Aargau", cities: [{label: "", value: ""}]
                },
                {
                    value: "Appenzell Inner-Rhoden",
                    label: "Appenzell Inner-Rhoden", cities: [{label: "", value: ""}]
                },
                {
                    value: "Jura",
                    label: "Jura", cities: [{label: "", value: ""}]
                },
                {
                    value: "Kanton Aargau",
                    label: "Kanton Aargau", cities: [{label: "", value: ""}]
                },
                {
                    value: "Luzern",
                    label: "Luzern", cities: [{label: "", value: ""}]
                },
                {
                    value: "Morbio Inferiore",
                    label: "Morbio Inferiore", cities: [{label: "", value: ""}]
                },

                {
                    value: "Schwyz",
                    label: "Schwyz", cities: [{label: "", value: ""}]
                },
                {
                    value: "Solothurn",
                    label: "Solothurn", cities: [{label: "", value: ""}]
                },
                {
                    value: "Thurgau",
                    label: "Thurgau", cities: [{label: "", value: ""}]
                },

            ]
        }

    ]
};
